import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MomentModule } from 'ngx-moment';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { MenuModule } from 'primeng/menu';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { MultiSelectModule } from 'primeng/multiselect';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DynamicDialogModule } from 'primeng/dynamicdialog';

import {
    MD5Pipe,
    SplitPipe,
    TraversePipe,
    UrlEncodePipe,
    LineBreaksPipe,
    ArrayFilterPipe,
    UnitConvertPipe,
    SlugToTitlePipe,
    LoadTypeIconPipe,
    AddressFormComponent,
    InfoTooltipComponent,
    BreadcrumbsComponent,
    TransportModeIconPipe,
    ArrayFilterByObjectPipe,
    UserInfoTooltipComponent,
    LoadingIndicatorComponent,
    TransportModeTransformPipe,
    LocationTypeaheadComponent,
    ExpandCollapseButtonComponent,
    LocationTypeaheadHintDirective,
    LocationTypeaheadItemDirective,
    GooglePlacesAutocompleteDirective,
    LocationTypeaheadNotFoundDirective,
    LocationTypeaheadPlaceholderDirective,
} from '@qwyk/ui-standalone';
import { HubActivitiesModule } from '@qwyk/hub/activities';
import {
    QuotationsServiceBase,
    SharedStoresQuotationsModule,
} from '@qwyk/shared-stores/quotations';
import { HubSettingsUsersWithoutRoutingModule } from '@qwyk/hub/settings/users';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { HubQuotationsOffersWithoutRoutingModule } from '@qwyk/hub/quotations-offers';

import {
    QuotationCreateComponent,
    QuotationDetailComponent,
    QuotationDetailHeaderComponent,
    QuotationListWidgetComponent,
    QuotationNetworkInfoComponent,
    QuotationNetworkRateRequestComponent,
    QuotationOfferLinesComponent,
    QuotationOffersListComponent,
    QuotationRateRequestsListComponent,
    QuotationRequestDetailsComponent,
    QuotationRequestHistoryComponent,
    QuotationsListComponent,
    QuotationStatusBadgeComponent,
    QuotationViewCargoComponent,
    QuotationViewCargoLineComponent,
} from './components';
import { QuotationDetailPageComponent } from './pages';
import { QuotationsService } from './services/quotations.service';
import { QuotationListSearchFormComponent } from './components/quotation-list-search-form/quotation-list-search-form.component';

export function quotationsServiceFactory(
    http: HttpClient
): QuotationsServiceBase {
    return new QuotationsService(http);
}

@NgModule({
    imports: [
        CommonModule,
        MD5Pipe,
        SplitPipe,
        MenuModule,
        FormsModule,
        TableModule,
        RouterModule,
        MomentModule,
        TraversePipe,
        UrlEncodePipe,
        TooltipModule,
        DropdownModule,
        NgSelectModule,
        LineBreaksPipe,
        CalendarModule,
        ArrayFilterPipe,
        InputTextModule,
        SlugToTitlePipe,
        TranslateModule,
        UnitConvertPipe,
        LoadTypeIconPipe,
        FontAwesomeModule,
        InputNumberModule,
        MultiSelectModule,
        AutoCompleteModule,
        OverlayPanelModule,
        DynamicDialogModule,
        ReactiveFormsModule,
        HubActivitiesModule,
        BreadcrumbsComponent,
        InfoTooltipComponent,
        AddressFormComponent,
        TransportModeIconPipe,
        ArrayFilterByObjectPipe,
        UserInfoTooltipComponent,
        LoadingIndicatorComponent,
        TransportModeTransformPipe,
        LocationTypeaheadComponent,
        ExpandCollapseButtonComponent,
        LocationTypeaheadHintDirective,
        LocationTypeaheadItemDirective,
        GooglePlacesAutocompleteDirective,
        LocationTypeaheadNotFoundDirective,
        HubSettingsUsersWithoutRoutingModule,
        LocationTypeaheadPlaceholderDirective,
        HubQuotationsOffersWithoutRoutingModule,
        SharedStoresQuotationsModule.forFeature({
            service: {
                provide: QuotationsServiceBase,
                useFactory: quotationsServiceFactory,
                deps: [HttpClient],
            },
        }),
    ],
    declarations: [
        QuotationsListComponent,
        QuotationOffersListComponent,
        QuotationRateRequestsListComponent,
        QuotationDetailComponent,
        QuotationOfferLinesComponent,
        QuotationCreateComponent,
        QuotationListWidgetComponent,
        QuotationStatusBadgeComponent,
        QuotationNetworkInfoComponent,
        QuotationNetworkRateRequestComponent,
        QuotationListSearchFormComponent,
        QuotationViewCargoComponent,
        QuotationViewCargoLineComponent,
        QuotationDetailPageComponent,
        QuotationDetailHeaderComponent,
        QuotationRequestDetailsComponent,
        QuotationRequestHistoryComponent,
    ],
    exports: [QuotationListWidgetComponent],
})
export class HubQuotationsWithoutRoutingModule {}
